import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M5.807 4.112A1.62 1.62 0 1 0 5.113.947a1.62 1.62 0 0 0 .694 3.165"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeWidth={1.2}
      d="M15.88 4.905c.82-.072 2.149-.471 2.767.294.619.766.837 1.62.902 2.055M9.767 5.795c-2.158.256-8.073 2.22-7.602 4.37"
    />
    <path
      strokeWidth={1.2}
      d="m4.743 10.465 7.617-7.243a1.27 1.27 0 0 1 1.829.08l3.764 4.266"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      fill="currentColor"
      d="m2.117 9.926.416-.432a.6.6 0 0 0-1.002.56zm21.217 5.967a.6.6 0 0 0-1.175.242l.588-.12zM21.64 10.85l-.59.116zm-2.766 5.58a.6.6 0 0 0 1.01.646l-.505-.323zM8.606 22.7l-.13-.585zM21.154 8.639l.582-.147zM4.832 10.446l.129.586 14.176-3.11-.128-.585-.129-.586L4.704 9.86zm15.173 9.762-.127-.587c-3.065.664-7.636 1.657-11.402 2.494l.13.586.13.585c3.762-.836 8.331-1.829 11.396-2.492zm-15.686-.239.586-.128L2.703 9.798l-.586.128-.586.129 2.202 10.043zM2.117 9.926l-.417.432c.459.442 1.646 1.028 3.26.674l-.128-.586-.128-.586c-1.222.268-2.001-.202-2.171-.366zm19.037-1.288-.582.146c.134.531.285 1.196.479 2.182l.589-.116.588-.115a43 43 0 0 0-.492-2.244zm.486 2.212-.59.116c.06.299-.066.764-.463 1.332-.381.547-.946 1.088-1.555 1.501-.618.42-1.216.663-1.655.694-.212.016-.352-.02-.44-.071-.08-.046-.166-.129-.232-.313l-.565.2-.566.2c.149.42.408.75.768.955.35.2.744.253 1.12.226.739-.053 1.542-.421 2.244-.898.713-.484 1.39-1.125 1.865-1.807.461-.66.81-1.47.657-2.25zm-5.5 3.46.566-.201c-.115-.322-.103-.544-.057-.69a.7.7 0 0 1 .3-.376c.336-.221.906-.305 1.468-.153.548.149.974.49 1.134.984.163.5.11 1.326-.677 2.555l.505.324.505.323c.891-1.392 1.125-2.6.809-3.572-.317-.977-1.133-1.547-1.962-1.772-.816-.221-1.758-.142-2.443.31a1.9 1.9 0 0 0-.784 1.017c-.14.444-.112.936.07 1.45zM8.606 22.7l-.13-.585a2.99 2.99 0 0 1-3.57-2.274l-.587.128-.586.129a4.19 4.19 0 0 0 5.003 3.188zm11.399-2.492.127.586a4.157 4.157 0 0 0 3.202-4.901l-.587.121-.588.121a2.957 2.957 0 0 1-2.281 3.486zm-.996-12.871.128.586c.645-.141 1.281.249 1.435.861l.582-.146.582-.147c-.319-1.268-1.606-2.014-2.856-1.74z"
    />
  </svg>
);
export const FinancialCoach01Icon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
